import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-form-password-errors',
  templateUrl: './form-password-errors.component.html',
  styleUrls: ['./form-password-errors.component.scss']
})
export class FormPasswordErrorsComponent {
  @Input() control!: AbstractControl;
  @Input() showCondition = true;

  constructor() { }
}
